// Meta Pixel helper — Pixel ID: 1283250386981385

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: unknown
  }
}

export function initPixel() {
  try {
    if (typeof window === 'undefined' || typeof document === 'undefined') return
    if (window.fbq) return

    // Inject fbq stub
    const n: any = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
    }
    window.fbq = n
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    // Inject script safely
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const target = document.head || document.documentElement
    target.appendChild(script)

    // Init & PageView
    window.fbq('init', '1283250386981385')
    window.fbq('track', 'PageView')
  } catch (e) {
    // Fail silently — never break the app
  }
}

export function trackAddToCart() {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Rutina Antiarrugas 40+ en 7 Días — Exosome Express',
        content_ids: ['52895245762903'],
        content_type: 'product',
        value: 6.39,
        currency: 'EUR',
      })
    }
  } catch (e) {
    // Fail silently
  }
}
